import { getIntegerValue, getStringValue, getTimestamp } from "../firestore/firestore.functions";
import { HttpFirestoreDocument } from "../firestore/firestore.types";
import { Brawlers, HttpFirestoreBrawlers } from "./brawlers.types";

export const getBrawlers = async (): Promise<Brawlers> => {
  return await getBrawlersFromFirestoreHttp()
};

const getBrawlersFromFirestoreHttp = async (): Promise<Brawlers> => {
  try {
    const brawlersResponse = await fetch(`https://firestore.googleapis.com/v1/projects/topbrawl-d96ec/databases/(default)/documents/all-brawlers/all-brawlers?key=AIzaSyAHrKlPV1fy5MMksth6i89FcsNf8ZN-yao`);
    const brawlersJson = await brawlersResponse.json();
    const brawlersTyped = brawlersJson as HttpFirestoreDocument<HttpFirestoreBrawlers>;
    const brawlers = convertHttpFirestoreBrawlersToBrawlers(brawlersTyped)
    return brawlers
  } catch (error) {
    throw new Error(`${error}`);
  }
};

const convertHttpFirestoreBrawlersToBrawlers = (firestoreBrawler: HttpFirestoreDocument<HttpFirestoreBrawlers>): Brawlers => {
  const fields = firestoreBrawler.fields;
  const brawlerStats: Brawlers = {
    brawlers: fields.brawlers.arrayValue.values.map(brawler => ({
      id: getIntegerValue(brawler.mapValue.fields.id)!,
      name: getStringValue(brawler.mapValue.fields.name)!,
    })),
    updatedAt: getTimestamp(fields.updatedAt)
  };

  return brawlerStats;
};
